function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18n from 'invision-core/src/components/i18n/i18n';
import CustomerCareLocaleKeys from '../../../../locales/keys';
export var SORT_FIELD_NAME = {
  CHARGE: 'charge',
  DATE: 'dateTime',
  USAGE: 'usage'
};
export var USAGE_SORT_FIELD = _defineProperty(_defineProperty(_defineProperty({}, SORT_FIELD_NAME.DATE, 0), SORT_FIELD_NAME.USAGE, 1), SORT_FIELD_NAME.CHARGE, 2);
export var USAGE_SORT_DIRECTION = {
  ASCENDING: 1,
  DESCENDING: 2
};
export var USAGES_LIMIT_WARNING_CODE = 1365;
export var ENTITLEMENT_ACTIVATION_STATUS = {
  //ENTITLEMENT_INACTIVE: 0,
  // ENTITLEMENT_ACTIVE:1,
  AWAITING_ENTITLEMENT_FIRST_USE: 2,
  AWAITING_SERVICE_FIRST_USE: 3,
  AWAITING_PAYMENT_CONFIRMATION: 4,
  AWAITING_ENTITLEMENT_FIRST_USE_WITH_PRICING_PLAN: 5
  // ENTITLEMENT_EXPIRED:20,
  //ENTITLEMENT_RENEWED:21,
  //ENTITLEMENT_PRODUCT_REMOVED:22
};
export var getColumnDefinitions = function getColumnDefinitions(uiGridConstants) {
  return [{
    field: SORT_FIELD_NAME.DATE,
    displayName: i18n.translate(CustomerCareLocaleKeys.USAGE_DETAILS.TABLE_HEADERS.DATE_TIME),
    cellTemplate: require('./cellTemplates/datetime.template.html'),
    enableSorting: true,
    type: 'numberStr',
    sort: {
      direction: uiGridConstants.DESC
    }
  }, {
    field: 'processDate',
    displayName: i18n.translate(CustomerCareLocaleKeys.USAGE_DETAILS.TABLE_HEADERS.PROCESS_DATE)
  }, {
    field: 'callCategory',
    displayName: i18n.translate(CustomerCareLocaleKeys.USAGE_DETAILS.TABLE_HEADERS.CALL_CATEGORY),
    enableSorting: true
  }, {
    field: 'entitlementName',
    displayName: i18n.translate(CustomerCareLocaleKeys.USAGE_DETAILS.TABLE_HEADERS.ENTITLEMENT_NAME),
    enableSorting: true
  }, {
    field: 'direction',
    displayName: i18n.translate(CustomerCareLocaleKeys.USAGE_DETAILS.TABLE_HEADERS.DIRECTION)
  }, {
    field: 'receiverWithLocation',
    displayName: i18n.translate(CustomerCareLocaleKeys.USAGE_DETAILS.TABLE_HEADERS.TO),
    cellTemplate: require('./cellTemplates/receiver.with.location.template.html')
  }, {
    field: 'senderWithLocation',
    displayName: i18n.translate(CustomerCareLocaleKeys.USAGE_DETAILS.TABLE_HEADERS.FROM),
    cellTemplate: require('./cellTemplates/sender.with.location.template.html')
  }, {
    field: SORT_FIELD_NAME.USAGE,
    displayName: i18n.translate(CustomerCareLocaleKeys.USAGE_DETAILS.TABLE_HEADERS.USAGE_ACTUAL),
    cellTemplate: require('./cellTemplates/usage.template.html'),
    enableSorting: true
  }, {
    field: SORT_FIELD_NAME.CHARGE,
    displayName: i18n.translate(CustomerCareLocaleKeys.USAGE_DETAILS.TABLE_HEADERS.CHARGE),
    cellClass: 'c-dataType-number',
    cellTemplate: require('./cellTemplates/charge.template.html'),
    enableSorting: true,
    headerCellClass: 'c-dataType-charge'
  }].map(function (columnDef) {
    return Object.assign({
      enableSorting: false,
      enableColumnMoving: false,
      minWidth: 70,
      sortDirectionCycle: [uiGridConstants.DESC, uiGridConstants.ASC],
      width: '*'
    }, columnDef);
  });
};